import React from 'react'
type Props = {
  width?: string
  height?: string
  color?: string
}

function Delayed({ width = '24', height = '24', color = '#F4821F' }: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <circle
        cx='12'
        cy='12'
        r='12'
        fill='#F4821F'
      />
      <g clip-path='url(#clip0_110_3266)'>
        <path
          d='M14.25 14.5H16.75L14.25 17H16.75M16.9753 12.5C16.9916 12.3355 17 12.1687 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17C12.0838 17 12.1672 16.9979 12.25 16.9939C12.3339 16.9897 12.4172 16.9835 12.5 16.9753M12 9V12L13.8692 12.9346'
          stroke='white'
          strokeWidth='1.2'
          strokeLinejoin='round'
          strokeLinecap='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_110_3266'>
          <rect
            width='12'
            height='12'
            fill='white'
            transform='translate(6 6)'
          />
        </clipPath>
      </defs>
    </svg>
  )
}

export default Delayed
